import { IconButton } from '@fukuri-admins/ui/common';
import { CrossIcon } from '@fukuri-admins/ui/common/Icons';
import { CREATE_PORTAL_ID } from '@fukuri-admins/ui/common/ModalDialog/constants';
import { useDisableModalBackScroll } from '@fukuri-admins/ui/common/ModalDialog/useDisableModalBackScroll';
import { useHandleKeyDown } from '@fukuri-admins/ui/common/ModalDialog/useHandleKeyDown';
import { ReactNode } from 'react';
import { portalModalVariants } from './logic';
import styles from './styles.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  variant?: 'md' | 'lg' | 'xl';
};

export const PortalModal: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  variant = 'md',
}) => {
  const element = document.getElementById(CREATE_PORTAL_ID);
  useDisableModalBackScroll({ isOpen });
  useHandleKeyDown({ isOpen, onClose });

  if (!isOpen || !element) return null;

  const className = portalModalVariants({ variant });

  return (
    <div className={styles.overlay}>
      <div
        role='dialog'
        aria-modal='true'
        onClick={e => e.stopPropagation()}
        className={styles.innerWrapper}
      >
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <IconButton
              variant='ghost'
              size='md'
              icon={<CrossIcon size='xs' />}
              onClick={onClose}
              aria-label='モーダルを閉じる'
              className={styles.closeButton}
            />
            <div className={className}>
              <div className={styles.title}>{title}</div>
              {description && <div className={styles.description}>{description}</div>}
              <div>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
